import { useEffect, useState } from "react";
import { Feather } from "lucide-react";
import { scrollToSection } from "../../lib/scroll";

const FloatingWrite = () => {
    const [atContact, setAtContact] = useState(false);

    useEffect(() => {
        const contact = document.querySelector('[data-testid="contact-section"]');
        if (!contact) return;
        const obs = new IntersectionObserver(([e]) => setAtContact(e.isIntersecting), {
            threshold: 0.12,
        });
        obs.observe(contact);
        return () => obs.disconnect();
    }, []);

    return (
        <button
            data-testid="floating-write-button"
            onClick={() => scrollToSection("#contacto")}
            aria-label="Escríbeme una carta"
            className={`fixed bottom-5 right-5 sm:bottom-8 sm:right-8 z-40 flex items-center gap-2.5 border border-ink bg-paper/90 backdrop-blur-md px-5 py-3.5 font-mono text-[10px] uppercase tracking-[0.25em] text-ink shadow-lg hover:bg-ink hover:text-paper transition-all duration-500 ${
                atContact ? "opacity-0 pointer-events-none translate-y-3" : "opacity-100"
            }`}
        >
            <Feather size={13} />
            Escríbeme
        </button>
    );
};

export default FloatingWrite;
